import Vue from 'vue'

import Vuex from 'vuex'
import StoreConstants from './StoreConstants';

import Cart from './modules/Cart';

import EventBus from '../event-bus';

Vue.prototype.$STORE_CONSTANTS = StoreConstants;
Vue.use(Vuex);

function initialState() {
    return {
        session_context : null,
        searchCache : {},
        searchGroupCollapseState : {},
        orderFilters : {},
    };
}

export default new Vuex.Store({
    modules : {
        [StoreConstants.CART] : Cart,
    },
    state : {
        dealer_portal : {},
        ...initialState(),
    },
    mutations : {
        resetState : (state) => {
            const s = initialState();
            Object.keys(s).forEach(key => state[key] = s[key]);
        },
        setDealerPortal : (state, settings) => {
            state.dealer_portal = settings;
        },
        setOrderFilters : (state, settings) => {
            state.orderFilters = settings;
        },
        setSessionContext : (state, session_context) => {
            state.session_context = session_context;
            if(session_context) {
                EventBus.emit(EventBus.EVENT.SESSION_SET, session_context.dealer.id);
            }
        },
        setSearchCache : (state, settings) => {
            state.searchCache[settings.cacheKey] = settings.cacheValue;
        },
        setSearchGroupCollapse : (state, context) => {
            Vue.set(state.searchGroupCollapseState, context.uniqueId, context.collapsed);
        },
    },
    actions : {
    }
})
